
import { Action } from '@ngrx/store';



export enum BuyerActionTypes {
  BUYER = 'BUYER',
  BUYER_SUCCESS  = 'BUYER_SUCCESS',
  BUYER_FAILURE  = 'BUYER_FAILURE',
}

export class Buyer implements Action {
  readonly type = BuyerActionTypes.BUYER;
  
}
export class BuyerSuccess implements Action {
  readonly type = BuyerActionTypes.BUYER_SUCCESS;
  constructor(public payload: any) {}
}


export class BuyerFailure implements Action {
  readonly type = BuyerActionTypes.BUYER_FAILURE;
  constructor(public payload: any) {}
}

export type All =
  | Buyer
  | BuyerSuccess
  | BuyerFailure;